import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class DespachoNoLocalService {
  
  apiService: any;

  constructor() { }
  noLocal(vm, dados) {
    dados.data_andamento = vm.dataHoraDoSistema;
    return true; 
  } 
}


// WEBPACK FOOTER //
// ./src/app/services/despacho-no-local.service.ts